// Ad-campaign and click-id parameters of a landing URL (utm_source, gclid, …).
//
// posthog-js reads them from the address bar when it sends an event — and it
// starts a moment after the page loads, so anything that rewrites the URL first
// (a short link's redirect, a legacy novel link upgraded to its short form) must
// carry them over, or the visit is counted as "direct". Only these parameters
// travel: others (e.g. an auth callback's `code`) are left behind on purpose.

/** The parameters posthog-js treats as campaign data (its CAMPAIGN_PARAMS, v1.434). */
export const CAMPAIGN_PARAM_NAMES: readonly string[] = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gad_source",
  "mc_cid",
  "gclid",
  "gclsrc",
  "dclid",
  "gbraid",
  "wbraid",
  "fbclid",
  "msclkid",
  "twclid",
  "li_fat_id",
  "igshid",
  "ttclid",
  "rdt_cid",
  "epik",
  "qclid",
  "sccid",
  "irclid",
  "_kx"
];

/** The campaign parameters in a query string (`?a=1&utm_source=x`), empty values skipped. */
export function campaignParams(search: string): Record<string, string> {
  const params = new URLSearchParams(search);
  const found: Record<string, string> = {};
  for (const name of CAMPAIGN_PARAM_NAMES) {
    const value = params.get(name);
    if (value) found[name] = value;
  }
  return found;
}

/**
 * Just the campaign parameters of `search`, as a query string ("" when there are
 * none). The pairs are copied as written, not re-encoded, so the address bar
 * keeps exactly what the link carried.
 */
export function campaignSearch(search: string): string {
  const kept = search
    .replace(/^\?/, "")
    .split("&")
    .filter((pair) => {
      const eq = pair.indexOf("=");
      if (eq <= 0 || eq === pair.length - 1) return false;
      try {
        return CAMPAIGN_PARAM_NAMES.includes(decodeURIComponent(pair.slice(0, eq).replace(/\+/g, " ")));
      } catch {
        return false;
      }
    });
  return kept.length > 0 ? `?${kept.join("&")}` : "";
}
